import React, { FC } from 'react';
import ModalContainer from 'react-modal-promise';
import { Route, Routes } from 'react-router-dom';
import '@itransition-epia/itransition-ui-components/lib/cjs/styles.css';
import { Layout } from 'antd';
import { SideMenu } from 'components/side-menu';
import { Dashboard } from 'pages/dashboard';
import { MyProfile } from 'pages/my-profile';
import { ViewDashboard } from 'pages/view-dashboard';
import { ViewProfile } from 'pages/view-profile';
import './app.less';
import {
  ROOT,
  SKILLS,
  VIEW_DASHBOARD,
  VIEW_PROFILE,
} from './common/constants/routes';

const { Sider, Content } = Layout;

export const App: FC = () => (
  <Layout className="app">
    <Sider breakpoint="md" collapsedWidth={70} width={220}>
      <SideMenu />
    </Sider>
    <Content>
      <Routes>
        <Route path={ROOT} element={<Dashboard />} />
        <Route path={SKILLS} element={<MyProfile />} />
        <Route path={VIEW_PROFILE} element={<ViewProfile />} />
        <Route path={VIEW_DASHBOARD} element={<ViewDashboard />} />
      </Routes>
    </Content>
    <ModalContainer />
  </Layout>
);
